/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Pagination } from '../models/Pagination';
import { ScanJobType } from '../models/ScanJobType';

export class ListScanJobTypesResponse {
  'scanJobTypes': Array<ScanJobType>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "scanJobTypes",
      "baseName": "scanJobTypes",
      "type": "Array<ScanJobType>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListScanJobTypesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

